/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalityNameModel
 */
export interface LocalityNameModel {
    /**
     * 
     * @type {number}
     * @memberof LocalityNameModel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LocalityNameModel
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof LocalityNameModel
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof LocalityNameModel
     */
    timezone: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocalityNameModel
     */
    labels: Array<string>;
}

export function LocalityNameModelFromJSON(json: any): LocalityNameModel {
    return LocalityNameModelFromJSONTyped(json, false);
}

export function LocalityNameModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalityNameModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'organizationId': json['organization_id'],
        'timezone': json['timezone'],
        'labels': json['labels'],
    };
}

export function LocalityNameModelToJSON(value?: LocalityNameModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'organization_id': value.organizationId,
        'timezone': value.timezone,
        'labels': value.labels,
    };
}

